<template lang="pug">

  div#transcription
    split-text( :type="'words'" :classname="'transcription-copy'") {{transcription}}

</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import WebAudioService from 'src/services/WebAudioService'
import ImageService from 'src/services/ImageService'
import Raf from 'src/helpers/Raf'
import SplitText from 'src/components/_utils/SplitText'

export default {

  name: 'transcription-text',
  
  components: {
    SplitText
  },
  
  data() {

    return { }
  },
  
  // props: {
  //   copy: String 
  // },

  computed: {
    ...mapState('question', [  
      'transcription'
    ]), 
  },
  
  mounted() { 
    this.list = this.$el.querySelectorAll('.transcription-copy');

    TweenMax.staggerTo(this.list, 1, {
      y: 0, 
      ease: 'Back.easeOut'
    }, 0.02);
  },
  
  beforeDestroy() {},
  
  methods: {
 
    setup: function() {}
  },
  
  watch: {
    'question.transcription' (val){
    }
  }

}

</script>

<style lang="sass">

  #transcription
    font-size: 1.8rem;
    letter-spacing: 0;
    padding: 1rem;
    top: 1rem;
    position: absolute;
    text-align: center;

    .step

      .transcription-copy
        transform: translate3d(0, 100px, 0);
        margin-bottom: 0.5rem;
        display: inline-block !important;
        background: #f8f4e2;
        color: #b0ac98;
        padding: 0.5rem;

</style> 